module.exports = __webpack_public_path__ + "img/verified.b0c186ab.svg";